"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areEqual = void 0;
var _lodash = _interopRequireDefault(require("lodash.isequal"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var areEqual = function areEqual(prevProps, nextProps) {
  var propsToCheck = ['hideLabel', 'invalid', 'light', 'label', 'required', 'validationMessage', 'validationMessageLeft', 'className', 'id'];
  var propsAreEqual = !propsToCheck.some(function (prop) {
    return prevProps[prop] !== nextProps[prop];
  });
  var childrenPropsAreEqual = (0, _lodash.default)(prevProps.children.props, nextProps.children.props);
  return propsAreEqual && childrenPropsAreEqual;
};
exports.areEqual = areEqual;